module.exports = __webpack_public_path__ + "img/home-07-cosmo-popup-bg-04.010b37e2.jpg";